import { render, staticRenderFns } from "./WorkDaysCalendar.vue?vue&type=template&id=32a55e18&scoped=true&"
import script from "./WorkDaysCalendar.vue?vue&type=script&lang=js&"
export * from "./WorkDaysCalendar.vue?vue&type=script&lang=js&"
import style0 from "./WorkDaysCalendar.vue?vue&type=style&index=0&id=32a55e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a55e18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBadge,VCard,VChip,VCol,VIcon,VRow,VSimpleTable,VSkeletonLoader})
